import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Avatar,
  IconButton,
  Typography,
  useTheme,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faEdit } from "@fortawesome/free-solid-svg-icons";
import useAdminStatus from "../../Hooks/useAdminStatus";

function UserCard({ user, onEdit, onDelete }) {
  const theme = useTheme();
  const { isAdmin } = useAdminStatus(); // Custom hook to get admin status

  return (
    <Card sx={{ backgroundColor: theme.palette.success.main, color: theme.palette.success.text }}>
      <CardHeader
        avatar={
          <Avatar
            sx={{
              fontSize: "0.8em",
              color: theme.palette.success.text,
              bgcolor: theme.palette.primary.main,
            }}
          >
            {user.Identifier.charAt(0)}
          </Avatar>
        }
        title={user.Identifier}
        subheader={user.Email}
        action={
          // Conditionally show icons only if the user is an admin
          isAdmin && (
            <>
              <IconButton
                onClick={() => onEdit(user)}
                sx={{ color: theme.palette.primary.main }}
              >
                <FontAwesomeIcon icon={faEdit} />
              </IconButton>
              <IconButton
                onClick={() => onDelete(user)}
                sx={{ color: theme.palette.error.main }}
              >
                <FontAwesomeIcon icon={faTrash} />
              </IconButton>
            </>
          )
        }
      />
      <CardContent>
        <Typography variant="body2" color={theme.palette.success.text}>
          Admin: {user.isAdmin ? "Yes" : "No"}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default UserCard;
